import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[InvolvementType SetFilter] Action',
  ResetFilter: '[InvolvementType ResetFilter] Action',
}

const initialInvolvementTypeState: IInvolvementTypeState = {
  filter: {
    status: 'active',
    active: true,
  },
}

export interface IInvolvementTypeState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-InvolvementType', whitelist: ['filter']},
  (state: IInvolvementTypeState = initialInvolvementTypeState, action: ActionWithPayload<IInvolvementTypeState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialInvolvementTypeState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
